

/* Style the AfterSell PDP widget inside its shadow DOM. */
(() => {
  const css = '.upsell-header{font-weight:700!important;text-transform:uppercase!important}.product-title,.product-title a{font-weight:700!important}.add-button{font-weight:700!important;text-transform:uppercase!important;letter-spacing:.06em!important}';
  const styleShadowRoots = (root = document) => {
    root.querySelectorAll('*').forEach((element) => {
      if (!element.shadowRoot) return;
      if (!element.shadowRoot.querySelector('#non-aftersell-typography')) {
        const style = document.createElement('style');
        style.id = 'non-aftersell-typography';
        style.textContent = css;
        element.shadowRoot.appendChild(style);
      }
      styleShadowRoots(element.shadowRoot);
    });
  };
  const apply = () => styleShadowRoots(document);
  apply();
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
})();


/* Keep the selected color's thumbnail visible in the mobile gallery. */
(() => {
  if (window.__nonMobileThumbReveal) return;
  window.__nonMobileThumbReveal = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.non-product-swatches button, .non-product-swatches .non-swatch');
    if (!swatch || window.innerWidth > 749) return;

    window.setTimeout(() => {
      const strip = document.querySelector('.non-product-thumbs');
      if (!strip) return;

      const label = (swatch.getAttribute('aria-label') || swatch.getAttribute('title') || swatch.textContent || '').trim().toLowerCase();
      const thumbs = Array.from(strip.querySelectorAll('[data-gallery-thumb]'));
      let selected = thumbs.find((thumb) => {
        const image = thumb.querySelector('img');
        return ((thumb.getAttribute('aria-label') || '') + ' ' + (image?.alt || '')).toLowerCase().includes(label);
      });

      if (!selected && label.includes('navy')) selected = thumbs[thumbs.length - 1];
      if (!selected) selected = strip.querySelector('[data-gallery-thumb].is-selected');
      if (!selected) return;

      strip.scrollTo({
        left: Math.max(0, selected.offsetLeft - strip.offsetLeft - 8),
        behavior: 'smooth'
      });
    }, 180);
  });
})();
const setModBundlesCartMode = () => {
  const data = document.querySelector('#pack-builder-data');
  if (!data) return false;
  try {
    const settings = JSON.parse(data.textContent || '{}');
    settings.cartSettings = {
      ...(settings.cartSettings || {}),
      redirectToCart: false,
      redirectToCheckout: false
    };
    data.textContent = JSON.stringify(settings);
    return true;
  } catch (error) {
    console.warn('Unable to set MOD Bundles cart behavior.', error);
    return false;
  }
};

if (!setModBundlesCartMode()) {
  const modBundlesObserver = new MutationObserver(() => {
    if (setModBundlesCartMode()) modBundlesObserver.disconnect();
  });
  modBundlesObserver.observe(document.documentElement, { childList: true, subtree: true });
}


const initNightOps = () => {
  const pageUrl = new URL(window.location.href);
  if (pageUrl.searchParams.get('open_cart') === '1') {
    pageUrl.searchParams.delete('open_cart');
    window.history.replaceState({}, '', `${pageUrl.pathname}${pageUrl.search}${pageUrl.hash}`);
    let cartAttempts = 0;
    const openMonsterDrawer = () => {
      const wrapper = document.querySelector('#monster-cart-wrapper');
      const cartLink = document.querySelector('a[href="/cart"]');
      if (wrapper && cartLink) {
        cartLink.click();
        window.setTimeout(() => {
          if (!wrapper.classList.contains('mu_openned') && cartAttempts < 50) {
            cartAttempts += 1;
            openMonsterDrawer();
          }
        }, 100);
        return;
      }
      cartAttempts += 1;
      if (cartAttempts < 50) window.setTimeout(openMonsterDrawer, 100);
      else window.location.replace('/cart?drawer_fallback=1');
    };
    window.setTimeout(openMonsterDrawer, 100);
  }
  const backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    const updateBackToTop = () => backToTop.classList.toggle('is-visible', window.scrollY > 700);
    window.addEventListener('scroll', updateBackToTop, { passive: true });
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    updateBackToTop();
  }
  const switchImage = (image, source) => {
    if (!image || !source) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = source.startsWith('//') ? `${window.location.protocol}${source}` : source;
  };
  const familySection = document.querySelector('.non-mission-split.is-reverse');
  if (familySection && !familySection.id) familySection.id = 'meet-the-family';
  document.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.addEventListener('click', () => {
    const image = document.querySelector('[data-product-main-image]');
    switchImage(image, button.dataset.image);
    document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-selected'));
    button.classList.add('is-selected');
  }));
  document.querySelectorAll('[data-non-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-id]');
    const picker = form.querySelector('[data-variant-picker]');
    if (!select || !picker) return;
    const variants = JSON.parse(picker.querySelector('[data-product-variants]')?.textContent || '[]');
    const chosen = {};
    picker.querySelectorAll('[data-option-position]').forEach((field) => {
      const selectedButton = field.querySelector('[data-option-value].is-selected');
      const optionSelect = field.querySelector('[data-option-select]');
      chosen[Number(field.dataset.optionPosition) - 1] = selectedButton?.dataset.optionValue || optionSelect?.value;
    });
    const updateVariant = () => {
      const fields = [...picker.querySelectorAll('[data-option-position]')];
      const hasUnselectedOption = fields.some((field) => !chosen[Number(field.dataset.optionPosition) - 1]);
      const variant = hasUnselectedOption ? null : variants.find((item) => item.options.every((value, index) => value === chosen[index]));
      picker.querySelectorAll('[data-option-position]').forEach((field) => {
        const position = Number(field.dataset.optionPosition) - 1;
        field.querySelectorAll('[data-option-value]').forEach((button) => {
          const possible = variants.some((item) => item.available && item.options[position] === button.dataset.optionValue && item.options.every((value, index) => index === position || !chosen[index] || value === chosen[index]));
          button.disabled = !possible;
          button.classList.toggle('is-unavailable', !possible);
          button.setAttribute('aria-disabled', String(!possible));
        });
      });
      const submit = form.querySelector('button[type="submit"]');
      if (!variant) {
        select.value = '';
        if (submit) {
          submit.disabled = true;
          submit.textContent = picker.querySelector('[data-size-option]') ? 'Choose a size' : 'Choose an option';
        }
        return;
      }
      select.value = variant.id;
        const currency = form.querySelector('[data-bundle-price]')?.dataset.currency || 'USD';
        const formatVariantPrice = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
        const priceElement = form.querySelector('[data-product-price]');
        const bundleElement = form.querySelector('[data-bundle-price]');
        if (priceElement) priceElement.textContent = formatVariantPrice(variant.price);
        if (bundleElement) {
          bundleElement.querySelectorAll('[data-bundle-rate]').forEach((amount) => {
        const rate = Number(amount.dataset.bundleRate) / 100;
        amount.textContent = formatVariantPrice(Math.round(variant.price * rate));
      });
          
          
        }
      const mainImage = document.querySelector('[data-product-main-image]');
      if (mainImage && variant.featured_image?.src) switchImage(mainImage, `${variant.featured_image.src}${variant.featured_image.src.includes('?') ? '&' : '?'}width=1400`);
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    };
    form.querySelectorAll('[data-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        const field = button.closest('[data-option-position]');
        chosen[Number(field.dataset.optionPosition) - 1] = button.dataset.optionValue;
        field.querySelectorAll('[data-option-value]').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        field.querySelector('[data-option-label]').textContent = button.dataset.optionValue;
        const image = document.querySelector('[data-product-main-image]');
        switchImage(image, button.dataset.image);
        updateVariant();
      });
    });
    form.querySelectorAll('[data-option-select]').forEach((optionSelect) => optionSelect.addEventListener('change', () => {
      const field = optionSelect.closest('[data-option-position]');
      chosen[Number(field.dataset.optionPosition) - 1] = optionSelect.value;
      field.querySelector('[data-option-label]').textContent = optionSelect.value;
      updateVariant();
    }));
    form.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => {
      const input = form.querySelector('input[name="quantity"]');
      const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityChange));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    form.addEventListener('submit', (event) => {
      if (select.value) return;
      event.preventDefault();
      picker.querySelector('[data-size-option]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    updateVariant();
  });
  document.querySelectorAll('.non-product-kit').forEach((link) => {
    const form = link.closest('[data-non-product-form]');
    const variantSelect = form?.querySelector('[data-variant-id]');
    if (!form || !variantSelect) return;
    link.addEventListener('click', (event) => {
      const variantId = variantSelect.value;
      if (!variantId) {
        event.preventDefault();
        form.querySelector('[data-size-option]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      event.preventDefault();
      const destination = new URL(link.href, window.location.origin);
      destination.searchParams.append('add_variant', variantId);
      window.location.assign(destination.toString());
    });
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    if (button?.textContent.trim() === 'ADD KIT TO CART') {
      let sawLoading = false;
      const openMonsterCart = (attempt = 0) => {
        sawLoading ||= button.dataset.loading === 'true';
        if (sawLoading && button.dataset.loading !== 'true') {
          document.querySelector('a[href="/cart"]')?.click();
          return;
        }
        if (attempt < 100) window.setTimeout(() => openMonsterCart(attempt + 1), 100);
      };
      window.setTimeout(() => openMonsterCart(), 0);
    }
  }, true);
  document.querySelectorAll('[data-card-swatch]').forEach((button) => {
    const card = button.closest('[data-product-card]');
    const image = card?.querySelector('[data-card-image]');
    if (!image) return;
    const original = image.src;
    button.addEventListener('mouseenter', () => switchImage(image, button.dataset.image));
    button.addEventListener('mouseleave', () => switchImage(image, original));
    button.addEventListener('focus', () => switchImage(image, button.dataset.image));
    button.addEventListener('blur', () => switchImage(image, original));
    button.addEventListener('click', () => {
      switchImage(image, button.dataset.image);
      card.querySelectorAll('[data-card-swatch]').forEach((item) => item.classList.remove('is-selected'));
      button.classList.add('is-selected');
    });
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNightOps);
else initNightOps();
(() => {
  const selector = 'details.non-product-details';

  function isFitDetails(details) {
    const label = details.querySelector(':scope > summary span');
    return label && label.textContent.trim().toLowerCase().endsWith('fit & sizing');
  }

  function enhance(details) {
    if (!isFitDetails(details) || details.dataset.fitModalEnhanced) return;

    const summary = details.querySelector(':scope > summary');
    const source = details.querySelector(':scope > div');
    if (!summary || !source) return;

    details.dataset.fitModalEnhanced = 'true';
    details.open = false;
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-haspopup', 'dialog');

    const dialog = document.createElement('dialog');
    dialog.className = 'non-fit-modal';
    dialog.setAttribute('aria-labelledby', 'non-fit-modal-title');
    dialog.innerHTML = `
      <div class="non-fit-modal__shell">
        <header class="non-fit-modal__header">
          <h2 class="non-fit-modal__title" id="non-fit-modal-title">Fit &amp; sizing</h2>
          <button class="non-fit-modal__close" type="button" aria-label="Close fit and sizing">×</button>
        </header>
        <div class="non-fit-modal__body">
          <details class="non-fit-modal__dropdown" open>
            <summary>Size chart &amp; measurements</summary>
            <div class="non-fit-modal__content"></div>
          </details>
        </div>
      </div>`;

    const content = dialog.querySelector('.non-fit-modal__content');
    while (source.firstChild) content.appendChild(source.firstChild);
    document.body.appendChild(dialog);

    const closeButton = dialog.querySelector('.non-fit-modal__close');
    let lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      details.open = false;
      document.documentElement.classList.add('non-fit-modal-open');
      document.body.classList.add('non-fit-modal-open');
      dialog.showModal();
      closeButton.focus();
    }

    function closeModal() {
      if (dialog.open) dialog.close();
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      openModal();
    });
    closeButton.addEventListener('click', closeModal);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeModal();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('non-fit-modal-open');
      document.body.classList.remove('non-fit-modal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    });

    dialog.querySelectorAll('.non-size-chart-scroll').forEach((scroller) => {
      scroller.addEventListener('wheel', (event) => {
        if (!window.matchMedia('(pointer: fine)').matches) return;
        if (scroller.scrollWidth <= scroller.clientWidth) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        event.preventDefault();
        scroller.scrollLeft += event.deltaY;
      }, { passive: false });
    });
  }

  function init(root = document) {
    root.querySelectorAll(selector).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(selector)) enhance(node);
        init(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();




/* GALLERY_INSERT_CHECK */
(() => {
  const enhanceGallery = (gallery) => {
    if (gallery.dataset.nonGalleryEnhanced) return;
    gallery.dataset.nonGalleryEnhanced = 'true';
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const stage = gallery.querySelector('.non-product-main-image');
    const image = gallery.querySelector('[data-product-main-image]');
    if (!thumbs.length || !stage || !image) return;
    let index = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-selected')));
    const select = (next) => {
      index = (next + thumbs.length) % thumbs.length;
      thumbs[index].click();
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-selected', i === index);
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => { index = i; }));
    stage.tabIndex = 0;
    stage.setAttribute('role', 'button');
    stage.setAttribute('aria-label', 'Enlarge product image. Use left and right arrow keys to change images.');
    let startX = 0;
    let startY = 0;
    stage.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', (event) => {
      if (!event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy)) select(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
    const desktop = matchMedia('(min-width: 750px)');
    let modal;
    const openZoom = () => {
      if (!desktop.matches) return;
      if (!modal) {
        modal = document.createElement('dialog');
        modal.className = 'non-gallery-lightbox';
        modal.setAttribute('aria-label', 'Enlarged product image');
        modal.innerHTML = '<button type="button" class="non-gallery-lightbox__close" aria-label="Close">×</button><button type="button" class="non-gallery-lightbox__arrow non-gallery-lightbox__arrow--prev" aria-label="Previous image">‹</button><div class="non-gallery-lightbox__canvas"><img alt=""></div><button type="button" class="non-gallery-lightbox__arrow non-gallery-lightbox__arrow--next" aria-label="Next image">›</button>';
        document.body.appendChild(modal);
        const move = (direction) => {
          select(index + direction);
          requestAnimationFrame(() => {
            const zoomed = modal.querySelector('img');
            zoomed.src = image.currentSrc || image.src;
            zoomed.alt = image.alt || 'Product image';
          });
        };
        modal.querySelector('.non-gallery-lightbox__close').addEventListener('click', () => modal.close());
        modal.querySelector('.non-gallery-lightbox__arrow--prev').addEventListener('click', () => move(-1));
        modal.querySelector('.non-gallery-lightbox__arrow--next').addEventListener('click', () => move(1));
        modal.addEventListener('click', (event) => { if (event.target === modal) modal.close(); });
        modal.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
        });
      }
      const zoomed = modal.querySelector('img');
      zoomed.src = image.currentSrc || image.src;
      zoomed.alt = image.alt || 'Product image';
      modal.showModal();
    };
    stage.addEventListener('click', openZoom);
    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); select(index - 1); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); select(index + 1); }
      else if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openZoom(); }
    });
  };
  const init = () => document.querySelectorAll('.non-product-gallery').forEach(enhanceGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
/* True desktop zoom: open fitted, then click the enlarged image to magnify */
document.addEventListener('click', (event) => {
  const zoomImage = event.target.closest('.non-gallery-lightbox__canvas img');
  if (!zoomImage) return;
  const lightbox = zoomImage.closest('.non-gallery-lightbox');
  lightbox.classList.toggle('is-zoomed');
});
document.addEventListener('close', (event) => {
  if (event.target.matches?.('.non-gallery-lightbox')) event.target.classList.remove('is-zoomed');
}, true);